import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import AssistPropertiesSelectModal, {
  ASSIST_PROPERTIES_SELECT_MODAL_ID,
} from './AssistPropertiesSelectModal';

const useAssistPropertiesSelectModal = () => {
  const { openModal } = useAppModal();
  const { t } = useTranslation();

  const openAssistPropertiesSelectModal = ({
    onUpdate,
    selectedProperties,
  }: {
    onUpdate: (properties: string[]) => void;
    selectedProperties: string[];
  }) => {
    openModal({
      id: ASSIST_PROPERTIES_SELECT_MODAL_ID,
      customContent: (
        <AssistPropertiesSelectModal
          onUpdate={onUpdate}
          selectedProperties={selectedProperties}
        />
      ),
      title: t('pageHostfullyAssist.details.propertiesSelectModal.title'),
    });
  };

  return { openAssistPropertiesSelectModal };
};

export default useAssistPropertiesSelectModal;
